import { IconButton, Tooltip, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { faLowVision } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from './icon/SparkelIcon';
import { useViewer } from './ForgeViewer';
import { useViewerMode, ViewerMode } from './viewer-mode';
import { GhostMode, useSheetViewer } from './SheetViewer';

export default function GhostModeButton(): React.ReactElement {
  const { viewerMode } = useViewerMode();
  const {
    ghosting: { setGhostMode: setGhostModeSheets, ghostMode: ghostModeSheets },
  } = useSheetViewer();
  const {
    setGhostMode: setGhostModeForge,
    isGhostModeActive: isGhostModeActiveForge,
  } = useViewer();

  const { t } = useTranslation('project');

  const isGhostModeActive =
    viewerMode === ViewerMode.Sheets
      ? ghostModeSheets !== GhostMode.NONE
      : isGhostModeActiveForge;

  const activeIconColor = useColorModeValue('teal.500', 'teal.200');
  const secondaryActiveIconColor = useColorModeValue(
    'orange.500',
    'orange.200'
  );
  const secondaryActiveBackgroundColor = useColorModeValue(
    'orange.100',
    'orange.900'
  );

  const colorScheme = isGhostModeActive
    ? ghostModeSheets === GhostMode.HIDDEN
      ? 'orange'
      : 'teal'
    : 'gray';

  return (
    <Tooltip
      label={
        viewerMode === ViewerMode.Sheets
          ? t('ghost-button.pdf')
          : t('ghost-button.bim')
      }
    >
      <IconButton
        aria-label="Ghosting"
        icon={
          <SparkelIcon
            icon={faLowVision}
            color={
              isGhostModeActive
                ? ghostModeSheets === GhostMode.HIDDEN
                  ? secondaryActiveIconColor
                  : activeIconColor
                : undefined
            }
          />
        }
        isRound
        isActive={isGhostModeActive && ghostModeSheets !== GhostMode.HIDDEN}
        backgroundColor={
          ghostModeSheets === GhostMode.HIDDEN
            ? secondaryActiveBackgroundColor
            : undefined
        }
        colorScheme={colorScheme}
        variant={isGhostModeActive ? 'toggle' : 'solid-no-transparent'}
        size="xs"
        onClick={() => {
          if (viewerMode === ViewerMode.Sheets) {
            setGhostModeSheets((ghostModeSheets + 1) % 3);
          } else {
            setGhostModeForge(!isGhostModeActiveForge);
          }
        }}
      />
    </Tooltip>
  );
}
